import { EmailCustomization } from '../../../api/configurations/customization/types';
import { Action, ActionType, EmailPreviewState, EmailTypes } from './types';
import { MAP_EMAILS_TO_FIELDS } from './utils';

export const initialState: EmailPreviewState = {
  emailCustomization: null,
  fetching: true,
  submitting: false,
  isPreview: true,
  emailType: EmailTypes.registrationConfirm,
  inputError: '',
  submitError: false
};

export const emailPreviewReducer = (
  state: EmailPreviewState,
  action: Action
): EmailPreviewState => {
  switch (action.type) {
    case ActionType.getEmailsSuccess:
      return {
        ...state,
        fetching: false,
        emailCustomization: action.payload as EmailCustomization
      };
    case ActionType.getEmailsFail:
      return { ...state, fetching: false };
    case ActionType.updateEmails:
      return {
        ...state,
        emailCustomization: {
          ...state.emailCustomization,
          ...(action.payload as EmailCustomization)
        }
      };
    case ActionType.changePreview:
      return { ...state, isPreview: !state.isPreview };
    case ActionType.changeInputError:
      return { ...state, inputError: action.payload as string };
    case ActionType.submitStarted:
      return { ...state, submitting: true, submitError: false };
    case ActionType.submitSuccess:
      return {
        ...state,
        submitting: false,
        emailCustomization: action.payload as EmailCustomization
      };
    case ActionType.submitFailed:
      return { ...state, submitting: false, submitError: true };
    case ActionType.setEmailType:
      return { ...state, emailType: action.payload as EmailTypes };
    default:
      throw new Error('Unknown action type in Email preview reducer!');
  }
};

export const selectCurrentEmail = (state: EmailPreviewState): string => {
  if (state.emailCustomization) {
    return <string>state.emailCustomization[MAP_EMAILS_TO_FIELDS[state.emailType]];
  }

  return '';
};
